import type { DeepPartial } from '@luna/utils-ts';

import type { UserProfileFeatureConfig } from './type';

export const userProfile: DeepPartial<UserProfileFeatureConfig> = {
    fetchEmployers: true,
};
